import { useLocation } from 'react-router-dom';
import {
  ErrorPanel,
  FullScreenOverlay,
  LoadingIndicator,
} from '@nbirl/nbi-common-ui-libs';

import { PATHS } from '../../shared/constants';
import { SidebarLayout } from '../../shared/layout';
import { ApiError } from '../../shared/models';
import { getErrorCodeMessage } from '../../shared/utils';
import {
  DashboardsSearch,
  DashboardsSidebar,
  DashboardsWorkbooks,
} from './components';
import { useDashboards } from './context';

export const DashboardsView = () => {
  const location = useLocation();
  const { dashboardWorkbooksQuery } = useDashboards();
  const { isError, isFetching, error } = dashboardWorkbooksQuery;

  const showSearchView = location.pathname.startsWith(PATHS.DashboardsSearch);
  const showWorkbooksView = location.pathname.startsWith(PATHS.Dashboards);

  if (isFetching || isError) {
    return (
      <FullScreenOverlay>
        {isFetching && <LoadingIndicator />}
        {isError && (
          <ErrorPanel error={getErrorCodeMessage(error as ApiError)} />
        )}
      </FullScreenOverlay>
    );
  }

  return (
    <SidebarLayout sidebar={<DashboardsSidebar />}>
      <div className="h-full min-w-3xl px-5 -mx-5">
        {showSearchView && <DashboardsSearch />}
        {showWorkbooksView && <DashboardsWorkbooks />}
      </div>
    </SidebarLayout>
  );
};
